import React, { useEffect, useRef, useState } from 'react'
import { Button, Checkbox, message, Tooltip, Image, Typography } from 'antd'
import _, { isArray } from 'lodash'
import styles from './index.module.less'
import SkuDynamicContent from '../SkuDynamicContent'
import { CopyOutlined, DoubleRightOutlined, DownOutlined, UpOutlined } from '@ant-design/icons'
const { Paragraph } = Typography
const KitDetailContent = ({
  disabled = false,
  kitList = [], //必选项
  noMustChooseList = [], // 可选项
  setMustChooseList = () => ({}),
  setNoMustChooseList = () => ({}),
  formatCombinationData = () => ({}),
}: any) => {
  // 动态属性
  const [showButtons, setShowButtons] = useState({})
  const elementRefs = useRef<Record<string, HTMLDivElement | null>>({})

  const changeChecked = (id: string, item: any, attr: any, isMust: boolean) => {
    if (disabled) {
      return
    }
    if (attr.disabled) {
      return
    }
    const list = isMust ? kitList : noMustChooseList
    const newList = list?.map((kit: any) => {
      if (kit.id === id) {
        const newDynamicList = kit.useArgList?.map((dynamicItem: any) => {
          if (dynamicItem.argCode === item.argCode) {
            const newList = dynamicItem?.list?.map((value: any) => {
              if (value.valueId === attr.valueId) {
                return {
                  ...value,
                  isActive: !value.isActive,
                  disabled: false,
                }
              }
              return {
                ...value,
                isActive: false,
                disabled: false,
              }
            })
            return {
              ...dynamicItem,
              list: newList,
            }
          } else {
            const newList = dynamicItem?.list?.map((value: any) => {
              return {
                ...value,
                disabled: false,
              }
            })
            return {
              ...dynamicItem,
              list: newList,
            }
          }
        })
        return {
          ...kit,
          useArgList: newDynamicList,
        }
      }
      return {
        ...kit,
      }
    })

    let newUseArgList: any = []
    let skuList: any = []
    /**
     * 找出选中的规格
     */
    const chooseArgMap: any = {}
    newList.forEach((item: any) => {
      if (item.id === id) {
        newUseArgList = _.cloneDeep(item.useArgList)
        skuList = _.cloneDeep(item.selectedSkuList)
        item.useArgList?.forEach((arg: any) => {
          if (arg?.list?.length) {
            arg?.list?.forEach((value: any) => {
              if (value.isActive) {
                chooseArgMap[arg.argCode] = value.valueId
              }
            })
          }
        })
      }
    })

    const cloneMap = _.cloneDeep(chooseArgMap)
    Object.keys(cloneMap)?.forEach((argCode: any) => {
      const useArgMap: any = {} // 所有用过的规格和值
      // 遍历过程中会改变chooseArgMap的值，可能出现不存在的情况
      if (!chooseArgMap?.[argCode]) {
        return
      }
      // 等于当前规格值的sku
      skuList
        .filter((sku: any) => sku?.argMap?.[argCode]?.valueId === chooseArgMap?.[argCode])
        ?.forEach((sku: any) => {
          const keys = Object.keys(sku?.argMap)
          keys.forEach(key => {
            // 正在选择的规格不能置灰
            if (key === argCode) {
              return
            }
            if (useArgMap[key]?.length) {
              if (!useArgMap[key].includes(sku?.argMap[key]?.valueId)) {
                useArgMap[key].push(sku?.argMap[key]?.valueId)
              }
            } else {
              useArgMap[key] = [sku?.argMap[key]?.valueId]
            }
          })
        })
      /**
       * 根据useArgMap处理规格的置灰逻辑， 如果之前已经选过的值被置灰，要把选择态取消并且从chooseArgMap中移除，避免后续继续筛选
       */
      newUseArgList = newUseArgList.map((arg: any) => {
        if (useArgMap[arg.argCode]?.length) {
          const newList = arg.list?.map((item: any) => {
            if (useArgMap[arg.argCode].includes(item.valueId)) {
              return {
                ...item,
                disabled: false,
              }
            } else {
              // 等于表明之前选中过，这个时候置灰就必须把之前选中的值去掉
              chooseArgMap[arg.argCode] =
                chooseArgMap[arg.argCode] === item.valueId ? '' : chooseArgMap[arg.argCode]
              return {
                ...item,
                isActive: false,
                disabled: true,
              }
            }
          })
          return {
            ...arg,
            list: newList,
          }
        }
        return {
          ...arg,
        }
      })
    })

    const formatList = newList.map((item: any) => {
      if (item.id === id) {
        return {
          ...item,
          useArgList: newUseArgList,
        }
      }
      return {
        ...item,
      }
    })
    if (isMust) {
      formatCombinationData(formatList, noMustChooseList, true, id)
    } else {
      formatCombinationData(kitList, formatList, true, id)
    }
  }
  const expandDetail = (id: string) => {
    const newList = kitList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: true,
        }
      }
      return {
        ...kit,
      }
    })
    setMustChooseList(newList)
  }

  const closeDetail = (id: string) => {
    const newList = kitList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: false,
        }
      }
      return {
        ...kit,
      }
    })
    setMustChooseList(newList)
  }

  const expandNoMustDetail = (id: string) => {
    const newList = noMustChooseList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: true,
        }
      }
      return {
        ...kit,
      }
    })
    setNoMustChooseList(newList)
  }

  const closeNoMustDetail = (id: string) => {
    const newList = noMustChooseList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: false,
        }
      }
      return {
        ...kit,
      }
    })
    setNoMustChooseList(newList)
  }

  // 单个选材勾选
  const singleMaterialCheck = (e: any, index: any) => {
    const newData = _.cloneDeep(noMustChooseList)
    newData[index].checked = e.target.checked
    formatCombinationData(kitList, newData, true)
  }

  const onSubmitSkuDynamicVoList = async (value, kit) => {
    console.log(value, 'value')
    if (value?.filter((item: any) => item.optionId).length !== kit.skuDynamicVoList?.length) return
    // 所有选项选完才更新
    const newData = kit.required ? _.cloneDeep(kitList) : _.cloneDeep(noMustChooseList)
    let currentIndex = newData.findIndex((item: any) => item.id === kit.id)
    newData[currentIndex].materialDynaOptions = value
    if (kit.required) {
      setMustChooseList(newData)
    } else {
      setNoMustChooseList(newData)
    }
  }

  const dynaOptionRender = (kit: any) => {
    // 只有一个sku的时候只展示规格内容
    if (kit.skuList?.length === 1) {
      let argMap = kit.skuList[0]?.argMap
      let str = ''
      Object?.keys(argMap)?.forEach((key: any) => {
        str += argMap[key]?.argName + '：' + argMap[key]?.valueName + '；'
      })
      return str
    }
  }
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }
  const getHeight = (index: any, type) => {
    let height: number = document.getElementById(type + index)?.scrollHeight || 0
    if (height > 420) {
      return true
    } else {
      return false
    }
  }
  useEffect(() => {
    const observers: ResizeObserver[] = []
    kitList.forEach(element => {
      // 为每个元素创建监听器
      element.useArgList.forEach(item => {
        const element = elementRefs.current[item.argId]
        if (!element) return

        const observer = new ResizeObserver(entries => {
          for (const entry of entries) {
            const height = entry.contentRect.height
            const shouldShowButton = height > 400 // 超过400px显示按钮

            setShowButtons(prev => ({
              ...prev,
              [item.argId]: shouldShowButton,
            }))
          }
        })

        observer.observe(element)
        observers.push(observer)
      })
    })
    // 清理函数
    return () => {
      observers.forEach(observer => observer.disconnect())
    }
  }, [kitList])
  useEffect(() => {
    const observers: ResizeObserver[] = []
    noMustChooseList.forEach(element => {
      // 为每个元素创建监听器
      element.useArgList.forEach(item => {
        const element = elementRefs.current[item.argId]
        if (!element) return

        const observer = new ResizeObserver(entries => {
          for (const entry of entries) {
            const height = entry.contentRect.height
            const shouldShowButton = height > 400 // 超过400px显示按钮

            setShowButtons(prev => ({
              ...prev,
              [item.argId]: shouldShowButton,
            }))
          }
        })

        observer.observe(element)
        observers.push(observer)
      })
    })
    // 清理函数
    return () => {
      observers.forEach(observer => observer.disconnect())
    }
  }, [noMustChooseList])
  const dialogContent = () => {
    return (
      <>
        <p className={styles.productGroupTitle}>产品包明细</p>
        <div className={styles.KitDetailDialogBox}>
          {kitList &&
            kitList?.length !== 0 &&
            kitList.map((kit: any, index: any) => {
              if (kit.allowView) {
                return (
                  <>
                    <div className={styles.orderDetail} key={'kit' + index}>
                      <div className={styles.orderDetailInfoBox}>
                        <div className={styles.imgBox}>
                          <Image.PreviewGroup items={kit?.product?.imageUrls || undefined}>
                            <Image src={kit?.mainPicUrl} className={styles.img} />
                          </Image.PreviewGroup>
                        </div>
                        <div className={styles.orderDetailInfo}>
                          <div className={styles.infoTitle}>
                            <div className={styles.descTitle}>
                              {/* {showNationalTagRender(kit)} */}
                              <Tooltip title={kit?.prodName} placement="topLeft">
                                <p> {kit?.prodName}</p>
                              </Tooltip>
                            </div>
                          </div>
                          <div className={styles.kitId}>
                            <span style={{ marginRight: '4px' }}>SPU: </span>
                            {kit?.id}
                            <CopyOutlined
                              style={{ marginLeft: '8px' }}
                              className="copyIcon"
                              onClick={() => {
                                clickToCopy(kit?.id)
                              }}
                            />
                          </div>
                          {kit.skuList?.length === 1 && dynaOptionRender(kit) && (
                            <div className={styles.footInfo}>
                              <div className={styles.houseInfo}>
                                <div>规格：{dynaOptionRender(kit)}</div>
                              </div>
                            </div>
                          )}

                          <div className={styles.footInfo}>
                            {kit.product?.brandName && (
                              <div className={styles.houseInfo}>
                                <div>品牌：{kit.product?.brandName}</div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {kit?.useArgList &&
                        kit?.useArgList?.length !== 0 &&
                        kit?.useArgList?.map((item: any, itemIndex: number) => {
                          return kit?.allowView ? (
                            <div key={'kitItem' + itemIndex} className={styles.chooseBox}>
                              <div className={styles.chooseTitle}>
                                <p className={styles.titleFont}>{item?.argName}</p>
                              </div>
                              <div style={{ flex: 1, overflow: 'hidden' }}>
                                <div
                                  key={'kitItemList' + itemIndex}
                                  className={styles.chooseList}
                                  ref={el => (elementRefs.current[item.argId] = el)}
                                  style={{ maxHeight: kit.isExpand ? 'fit-content' : '420px' }}
                                >
                                  {item?.list &&
                                    item?.list?.length !== 0 &&
                                    item?.list?.map((attr: any, attrIndex: number) => (
                                      <div
                                        key={'kitItemAttr' + attrIndex}
                                        className={`${styles.item} ${
                                          attr.isActive ? styles.itemActive : ''
                                        } ${attr.disabled ? styles.disabled : ''}`}
                                        onClick={() => {
                                          changeChecked(kit.id, item, attr, true)
                                        }}
                                      >
                                        <div className={styles.valueNameBox}>
                                          <Tooltip title={attr?.valueName} placement="topLeft">
                                            <p className={styles.overflowText}>
                                              {' '}
                                              {attr?.valueName}
                                            </p>
                                          </Tooltip>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                                {!kit.isExpand && showButtons[item.argId] ? (
                                  <div
                                    style={{
                                      cursor: 'pointer',
                                      fontSize: '14px',
                                      color: '#2D2D2E',
                                    }}
                                    onClick={() => {
                                      expandDetail(kit?.id)
                                    }}
                                  >
                                    展开全部
                                    <DownOutlined style={{ marginLeft: 4 }} />
                                  </div>
                                ) : null}
                                {kit.isExpand && showButtons[item.argId] ? (
                                  <div
                                    style={{
                                      cursor: 'pointer',
                                      fontSize: '14px',
                                      color: '#2D2D2E',
                                      marginTop: '8px',
                                    }}
                                    onClick={() => {
                                      closeDetail(kit?.id)
                                    }}
                                  >
                                    收起全部
                                    <UpOutlined style={{ marginLeft: 4 }} />
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          ) : null
                        })}
                      {/* 动态属性 */}
                      <SkuDynamicContent
                        loading={false}
                        formList={
                          kit?.materialDynaOptions
                            ? kit?.materialDynaOptions
                            : kit?.skuDynamicVoList
                        }
                        onSubmit={onSubmitSkuDynamicVoList}
                        currentItem={kit}
                      ></SkuDynamicContent>
                    </div>
                  </>
                )
              }
            })}
        </div>
        {noMustChooseList?.length ? (
          <>
            <div
              className={styles.classTitle}
              style={{ borderTop: '1px solid rgba(223, 225, 229, 1)' }}
            >
              可选项
            </div>
            <div className={styles.KitDetailDialogBox}>
              {noMustChooseList &&
                noMustChooseList?.length !== 0 &&
                noMustChooseList.map((kit: any, index: any) => {
                  if (kit.allowView) {
                    return (
                      <>
                        <div className={styles.orderDetail} key={'kit' + index}>
                          <div className={styles.orderDetailInfoBox}>
                            <div style={{ display: 'flex' }}>
                              <Checkbox
                                checked={kit.checked}
                                defaultChecked={kit.checked}
                                onChange={(e: any) => {
                                  singleMaterialCheck(e, index)
                                }}
                              ></Checkbox>
                            </div>
                            <div className={styles.imgBox}>
                              <Image.PreviewGroup items={kit?.product?.imageUrls || undefined}>
                                <Image src={kit?.mainPicUrl} className={styles.img} />
                              </Image.PreviewGroup>
                            </div>
                            <div className={styles.orderDetailInfo}>
                              <div className={styles.infoTitle}>
                                <div className={styles.descTitle}>
                                  {/* {showNationalTagRender(kit)} */}
                                  <Tooltip title={kit?.prodName} placement="topLeft">
                                    <span> {kit?.prodName}</span>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className={styles.kitId}>
                                <span style={{ marginRight: '4px' }}>SPU: </span>
                                {kit?.id}
                                <CopyOutlined
                                  style={{ marginLeft: '8px' }}
                                  className="copyIcon"
                                  onClick={() => {
                                    clickToCopy(kit?.id)
                                  }}
                                />
                              </div>
                              <div className={styles.footInfo}>
                                {kit.skuList?.length === 1 && dynaOptionRender(kit) && (
                                  <div className={styles.houseInfo}>
                                    <div>规格：{dynaOptionRender(kit)}</div>
                                  </div>
                                )}
                              </div>
                              <div className={styles.footInfo}>
                                {kit.product?.brandName && (
                                  <div className={styles.houseInfo}>
                                    <div>品牌：{kit.product?.brandName}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {kit.checked &&
                            kit?.useArgList &&
                            kit?.useArgList?.length !== 0 &&
                            kit?.useArgList?.map((item: any, itemIndex: number) => {
                              return (
                                <div key={'kitItem' + itemIndex} className={styles.chooseBox}>
                                  <div className={styles.chooseTitle}>
                                    <p className={styles.titleFont}>{item?.argName}</p>
                                  </div>
                                  <div style={{ flex: 1, overflow: 'hidden' }}>
                                    <div
                                      key={'kitItemList' + itemIndex}
                                      className={styles.chooseList}
                                      ref={el => (elementRefs.current[item.argId] = el)}
                                      style={{ maxHeight: kit.isExpand ? 'fit-content' : '420px' }}
                                    >
                                      {item?.list &&
                                        item?.list?.length !== 0 &&
                                        item?.list?.map((attr: any, attrIndex: number) => (
                                          <div
                                            key={'kitItemAttr' + attrIndex}
                                            className={`${styles.item} ${
                                              attr.isActive ? styles.itemActive : ''
                                            } ${attr.disabled ? styles.disabled : ''}`}
                                            onClick={() => {
                                              changeChecked(kit.id, item, attr, false)
                                            }}
                                          >
                                            <div className={styles.valueNameBox}>
                                              <Tooltip title={attr?.valueName} placement="topLeft">
                                                <p className={styles.overflowText}>
                                                  {' '}
                                                  {attr?.valueName}
                                                </p>
                                              </Tooltip>
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                    {!kit.isExpand && showButtons[item.argId] ? (
                                      <div
                                        style={{
                                          cursor: 'pointer',
                                          fontSize: '14px',
                                          color: '#2D2D2E',
                                        }}
                                        onClick={() => {
                                          expandNoMustDetail(kit?.id)
                                        }}
                                      >
                                        展开全部
                                        <DownOutlined style={{ marginLeft: 4 }} />
                                      </div>
                                    ) : null}
                                    {kit.isExpand && showButtons[item.argId] ? (
                                      <div
                                        style={{
                                          cursor: 'pointer',
                                          fontSize: '14px',
                                          color: '#2D2D2E',
                                          marginTop: '8px',
                                        }}
                                        onClick={() => {
                                          closeNoMustDetail(kit?.id)
                                        }}
                                      >
                                        收起全部
                                        <UpOutlined style={{ marginLeft: 4 }} />
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              )
                            })}
                          {/* 动态属性 */}
                          <SkuDynamicContent
                            loading={false}
                            formList={
                              kit?.materialDynaOptions
                                ? kit?.materialDynaOptions
                                : kit?.skuDynamicVoList
                            }
                            onSubmit={onSubmitSkuDynamicVoList}
                            currentItem={kit}
                          ></SkuDynamicContent>
                        </div>
                      </>
                    )
                  }
                })}
            </div>
          </>
        ) : null}
      </>
    )
  }

  return <div className={styles.KitDetailDialog}>{dialogContent()}</div>
}

export default KitDetailContent
